import React from 'react'
// import About from '../Component/About'
// import AboutBreadcrumb from '../Component/AboutBreadcrumb'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import BlogSection from '../Component/BlogSection'
import BlogBreadcrumb from '../Component/BlogBreadcrumb'
// import FAQ from '../Component/FAQ'
// import CourseSection from '../Component/CourseSection'
function BlogPage() {
    return (
        <div>
            <Header />
            <BlogBreadcrumb />
            <BlogSection />
            <Footer />
        </div>
    )
}

export default BlogPage